import loadable from "@loadable/component";
import { fetchReviewsPreview } from "../features/reviews/reviewsSlice";
import { fetchRegionalPrices } from "../features/regionalPrices/regionalPricesSlice";

const Landing = loadable(() => import("./Landing.page"));

const loadData = (store) => {
  const {
    localization: { data },
  } = store.getState();
  const actions = [fetchRegionalPrices(data), fetchReviewsPreview()];
  return Promise.all(actions.map((action) => store.dispatch(action)));
};

export default { component: Landing, loadData };
